import { render } from "./subscriptions.vue?vue&type=template&id=24044812&scoped=true"
import script from "./subscriptions.vue?vue&type=script&lang=js"
export * from "./subscriptions.vue?vue&type=script&lang=js"

import "./subscriptions.vue?vue&type=style&index=0&id=24044812&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24044812"]])

export default __exports__